import { pickAvatarColor } from './initials';

/**
 * Extract the user-picked tile colour from a wire-format
 * organisation row, falling back to the deterministic palette when
 * none is set. Mirrors the priority order in
 * `apps/mobile/features/data/adapters/organization.ts`:
 *
 *   1. branding.primaryColor (the value the design screen writes)
 *   2. branding.accent (legacy / alias)
 *   3. deterministic palette colour from id
 *
 * Accepts a loosely-typed branding bag so the helper works for both
 * `OrganizationListItem` and `Organization` without a discriminated
 * union — neither shape narrows the JSON contents at the type level.
 */
export function brandingColor(args: {
  id: string;
  branding?: unknown;
}): string {
  const branding =
    args.branding && typeof args.branding === 'object'
      ? (args.branding as Record<string, unknown>)
      : null;
  const primary = branding && typeof branding.primaryColor === 'string' ? branding.primaryColor : null;
  const accent = branding && typeof branding.accent === 'string' ? branding.accent : null;
  return primary ?? accent ?? pickAvatarColor(args.id);
}
